import { render } from "./TemplateRegistryComponent.vue?vue&type=template&id=1d16e9d8&scoped=true"
import script from "./TemplateRegistryComponent.vue?vue&type=script&lang=js"
export * from "./TemplateRegistryComponent.vue?vue&type=script&lang=js"

import "./TemplateRegistryComponent.vue?vue&type=style&index=0&id=1d16e9d8&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d16e9d8"]])

export default __exports__